import React from "react";

import Toggle from "material-ui/Toggle";
import { muiToggleStyle } from "ui-components";
import {
  RiskSelectorWrapper,
  RiskSelectorContent,
  RiskSelectorText,
  RiskSelectorButtons,
  RiskSelectorToggleLabel
} from "@common/styled/risk";

export const RiskList = (risks, activeSubStep, toggleIndicator) => {
  return risks.map((risk, riskIndex) => {
    return (
      <RiskSelectorWrapper key={riskIndex}>
        <RiskSelectorContent>
          <RiskSelectorText>
            {risk.question}
          </RiskSelectorText>
          <RiskSelectorButtons
            onClick={() => toggleIndicator(activeSubStep, riskIndex)}
          >
            <RiskSelectorToggleLabel>Yes</RiskSelectorToggleLabel>
            <Toggle
              key={risk}
              label="No"
              toggled={risk.isRisk}
              style={muiToggleStyle.style}
              labelPosition="right"
              labelStyle={muiToggleStyle.label}
            />
          </RiskSelectorButtons>
        </RiskSelectorContent>
      </RiskSelectorWrapper>
    );
  });
};



// WEBPACK FOOTER //
// ./src/pretravel/components/Content/Risks/riskList.jsx